import { MessageTemplatesUpdateParams } from "interfaces/TemplateEditor";
import { httpCollection } from "us.helper/http/collection";

export default {
  template: {
    getAllRules: (): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            "template/all/rules",
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    addRemoveFromMessageTemplates: (
      params: MessageTemplatesUpdateParams
    ): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationservice",
            "messagetemplate/update",
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  texts: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            `texts/${params}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  categoryDataAdapters: {
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            `adaptersplist`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  category: {
    save: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationservice",
            `category`,
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    update: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.put(
            "communicationservice",
            `category/${params.categoryId}`,
            params
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    get: (params: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            `category/${params.categoryId}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
  settings: {
    getAll: (settingName: string): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.get(
            "communicationservice",
            `settings/${settingName}`,
            {}
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
    update: (settings: any): Promise<any> => {
      return new Promise<any>(async (resolve, reject) => {
        try {
          const { data, status } = await httpCollection.post(
            "communicationservice",
            "settings",
            settings
          );
          resolve({ data, status });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};
